import { render, staticRenderFns } from "./return-order-com.vue?vue&type=template&id=39baf860&scoped=true"
import script from "./return-order-com.vue?vue&type=script&lang=js"
export * from "./return-order-com.vue?vue&type=script&lang=js"
import style0 from "./return-order-com.vue?vue&type=style&index=0&id=39baf860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39baf860",
  null
  
)

export default component.exports